<template>
  <div class="w-100 mx-auto">
    <VueApexCharts
      type="donut"
      :options="donutChart.options"
      :series="donutChart.series"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: {
    settings: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      donutChart: {
        series: [
          706, 8, 4, 759, 6, 4, 3, 148, 2, 136, 3, 86, 128, 74, 2, 335, 107, 16,
          15, 197,
        ],
        options: {
          labels: [
            "Cerun / Tanah Runtuh",
            "Bangunan / Rumah",
            "Jalan",
            "Longkang / Banjir",
            "Haiwan",
            "Taman Permainan",
            "Lampu / Lampu Isyarat",
            "Sampah",
            "Pembakaran Terbuka",
            "Parkir",
            "Pokok / Landskap",
            "Papan Tanda / Iklan",
            "Tandas",
            "Urus Tadbir PBT",
            "Premis Makanan",
            "Strata",
            "Pasar",
            "OKU",
          ],
          chart: {
            width: 380,
            type: "donut",
          },
          plotOptions: {
            pie: {
              startAngle: -90,
              endAngle: 270,

              donut: {
                size: "50%",
                labels: {
                  show: true,
                  name: {},
                  value: {},
                },
              },
            },
          },
          dataLabels: {
            enabled: true,
          },
          fill: {
            type: "gradient",
          },
          legend: {
            formatter: function (val, opts) {
              return val + " - " + opts.w.globals.series[opts.seriesIndex];
            },
          },
          // title: {
          //   text: "Gradient Donut with custom Start-angle",
          // },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
    };
  },
  components: {
    VueApexCharts,
  },
};
</script>
